module.exports = __webpack_public_path__ + "static/media/40.b94249ee.png";